import {
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Grid,
    TextField,
} from "@mui/material";
import { Formik } from "formik";
import { useState } from "react";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";

import DefaultApiService from "../../../../../infrastructure/api/default";
import { wrapFormikHandleChange } from "../../../../../infrastructure/utils/formatters";
import BreadcrumbsComponent from "../../../../components/shared/breadcrumbs";
import DropdownPicker from "../../../../components/shared/dropdown";
import JalaliDatePicker from "../../../../components/shared/jalali-datetimepicker";
import FileUploader from "../../../../components/shared/uploader/FileUploader";

const validationSchema = Yup.object().shape({
  title: Yup.string().required("لطفا این فیلد را پر کنید."),

  price: Yup.string().required("لطفا این فیلد را پر کنید."),
});

const CustomerSupplierProjectContractModifyPage = () => {
  const data = useLoaderData("root");
  let navigate = useNavigate();
  const { id: roleId } = useParams();

  const [loading, setLoading] = useState(false);

  const onNavigateToListPage = () => {
    navigate("/SLN/Customer/SupplierProjectContract");
  };

  // Submit Action
  const onSubmit = async (formValue, { setSubmitting }) => {
    setLoading(true);
    const sendData = { ...data.substation, ...formValue };

    try {
      const res = await DefaultApiService.modifyApi(
        "SLN/Customer/SupplierProjectContract",
        sendData
      );

      if (res.isSuccess) {
        toast.success(res.message);
        onNavigateToListPage();
      } else {
        toast.error(res.message);
      }

      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "خطایی رخ داده است.");

      setLoading(false);
      setSubmitting(false);
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>

      <Grid item xs={12} md={12}>
        <Card>
          <CardHeader
            title={
              roleId !== "create"
                ? `ویرایش ${data?.supplierProjectContract.title}`
                : "ایجاد"
            }
          />

          <CardContent>
            <Formik
              initialValues={data.supplierProjectContract}
              validationSchema={validationSchema}
              onSubmit={onSubmit}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                setFieldValue,
              }) => {
                const onMakeFormikVariable = (name) => ({
                  name: name,
                  fullWidth: true,
                  value: values[name],
                  error: errors[name] && touched[name],
                  helperText: errors[name] && touched[name] && errors[name],
                  variant: "outlined",
                });

                return (
                  <form onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          label="عنوان"
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("title")}
                        />
                      </Grid>
                      <Grid item xs={12} md={3} lg={3}>
                        <DropdownPicker
                          label="تامین کننده"
                          onChange={(event) => {
                            setFieldValue("supplierInfoId", event.target.value);
                          }}
                          list={data.suppliers}
                          optionName="title"
                          optionValue="id"
                          {...onMakeFormikVariable("supplierInfoId")}
                        />
                      </Grid>
                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          label="مبلغ پروژه"
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("price")}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          label="ظرفیت پروژه"
                          disabled={true}
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("projectCapacity")}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <TextField
                          label="عنوان پروژه"
                          disabled={true}
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("projectTitle")}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <JalaliDatePicker
                          label="تاریخ شروع قرارداد"
                          onChange={(value) => {
                            setFieldValue("startDateTime", value);
                          }}
                          {...onMakeFormikVariable("startDateTime")}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <JalaliDatePicker
                          label="تاریخ پایان قرارداد"
                          onChange={(value) => {
                            setFieldValue("endDateTime", value);
                          }}
                          {...onMakeFormikVariable("endDateTime")}
                        />
                      </Grid>

                      <Grid item xs={12} md={12} lg={6}>
                        <TextField
                          label="آدرس"
                          multiline
                          minRows={2}
                          onChange={wrapFormikHandleChange(handleChange)}
                          {...onMakeFormikVariable("address")}
                        />
                      </Grid>

                      <Grid item xs={12} md={12}>
                        <FileUploader
                          moduleName={"SLN/Contractor"}
                          maxFiles={1}
                          label="فایل "
                          onChange={(list) => {
                            console.log(list);

                            if (list.length > 0) {
                              setFieldValue("certificateUrl", list[0]);
                            } else {
                              setFieldValue("certificateUrl", "");
                            }
                          }}
                          baseurl={data.baseUrl}
                          placeholder={"فایل مورد نظر را انتخاب کنید"}
                          {...onMakeFormikVariable("certificateUrl")}
                        />
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        md={12}
                        container
                        justifyContent={"flex-end"}
                      >
                        <Button
                          disabled={isSubmitting}
                          variant="outlined"
                          size="large"
                          color="gray"
                          sx={{ mx: 1 }}
                          onClick={onNavigateToListPage}
                        >
                          انصراف
                        </Button>

                        <Button
                          disabled={isSubmitting}
                          variant="contained"
                          type="submit"
                          size="large"
                        >
                          {loading && (
                            <CircularProgress size={16} color="inherit" />
                          )}
                          {roleId !== "create" ? "ویرایش" : "ایجاد"}
                        </Button>
                      </Grid>
                    </Grid>
                  </form>
                );
              }}
            </Formik>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default CustomerSupplierProjectContractModifyPage;
